import Vue from 'vue';

export default Vue.mixin({
  data() {
    return {
      billingTabs: [
        {
          id: '1',
          title: 'Overview',
          url: 'billing-overview'
        },
        {
          id: '2',
          title: 'Usage',
          url: 'usage'
        },
        {
          id: '3',
          title: 'Payment methods',
          url: 'payment-methods'
        },
        {
          id: '4',
          title: 'Invoices',
          url: 'invoices'
        }
      ],
      accessTabs: [
        {
          id: '1',
          title: 'Credentials',
          url: 'credentials'
        },
        {
          id: '2',
          title: 'API Endpoints',
          url: 'api-endpoints'
        },
        {
          id: '3',
          title: 'API Credentials',
          url: 'access'
        },
      ],
      teamTabs: [
        {
          id: '1',
          title: 'Projects',
          url: 'team'
        },
        {
          id: '2',
          title: 'Users',
          url: 'account-users'
        },
      ],
    }
  }
});
